import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.services-slider' ).length ) {
        $( '.services-slider' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '1.5rem',
            perPage: 3,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              640: {
                perPage: 1,
              },
            },
          } );

          const applyOverflowState = ( isOverflow ) => {
            if ( !isOverflow ) {
              splide.options = {type: 'slide', arrows: false, drag: false};
              element.classList.add( 'is-static' );
            } else {
              splide.options = {type: 'loop', arrows: true, drag: true};
              element.classList.remove( 'is-static' );
            }
          };

          splide.on( 'overflow', applyOverflowState );

          let rafId;
          const refresh = () => {
            if ( rafId ) cancelAnimationFrame( rafId );
            rafId = requestAnimationFrame( () => splide.refresh() );
          };

          splide.on( 'resize', refresh );
          splide.on( 'updated', refresh );

          [window.matchMedia( '(max-width: 1024px)' ),
            window.matchMedia( '(max-width: 640px)' )].forEach( ( mq ) => {
            mq.addEventListener( 'change', refresh );
          } );

          splide.mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'services-slider', COMPONENT );
} )( app );
